import _ from 'lodash'
import axios from '../../../common/axios.js'
import {gmapApi} from 'vue2-google-maps'
import * as turf from '@turf/turf'
import proj4 from 'proj4';


export default {
	date(){
		return {
			gps_cancelSearch: null
		}
	},
	mounted(){},
	created(){},
	methods: {
		getSearch_gps(){
			let self = this			

			const trimmed = this.search_term.trim()
    
			//RZ--> Cas coordonnées décimales WGS84 (ex: 48.883440, 2.335654) ou Lambert 93 (ex: 1000000, 2000000)
			const decimalMatch = trimmed.match(/^(-?\d+[\.,]?\d*)\s*[;,]?\s*(-?\d+[\.,]?\d*)$/)
			if (decimalMatch) {
				const lat = parseFloat(decimalMatch[1].replace(',', '.'))
				const lng = parseFloat(decimalMatch[2].replace(',', '.'))

				//RZ--> Si la lat est en entier supérieur à 6 000 000 alors on considère que c'est un format Lambert 93
				if(lng > 6000000){
					let coordinates = self.convertLambert93ToWGS84(lat, lng)
					self.addCoordinates(coordinates)
				}else if(self.isValidWGS84(lat, lng)){
					let coordinates = [lng, lat]
					self.addCoordinates(coordinates)
				}				
			}

			//RZ--> Cas coordonnées DMS (ex: 48°53'06.4"N 2°20'14.4"E)
			const dmsMatch = trimmed.match(/^(\d+)°(\d+)'(\d+\.?\d*)"([NS])\s+(\d+)°(\d+)'(\d+\.?\d*)"([EW])$/)
			if (dmsMatch) {
				const latDeg = parseInt(dmsMatch[1])
				const latMin = parseInt(dmsMatch[2])
				const latSec = parseFloat(dmsMatch[3])
				const latDir = dmsMatch[4]
				
				const lngDeg = parseInt(dmsMatch[5])
				const lngMin = parseInt(dmsMatch[6])
				const lngSec = parseFloat(dmsMatch[7])
				const lngDir = dmsMatch[8]

				const lat = this.dmsToDecimal(latDeg, latMin, latSec, latDir)
				const lng = this.dmsToDecimal(lngDeg, lngMin, lngSec, lngDir)

				let coordinates = [lng, lat]
				self.addCoordinates(coordinates)
			}

			//RZ--> Cas coordonnées Plus Code Global (ex: 8FW4V8MP+2X)
			const regexGlobal = trimmed.match(/^([A-Z0-9]{8}\+[A-Z0-9]{2,3})$/);
			if(regexGlobal){
				self.convertPlusCodeToWGS84(regexGlobal)
			}

			//RZ--> Cas coordonnées Plus Code (ex: V8MP+2X Paris)
			const regexCompound = trimmed.match(/^([A-Z0-9]{4}\+[A-Z0-9]{2})[, ]+(.*)$/);
			if(regexCompound){
				self.convertPlusCodeToWGS84(regexCompound)
			}
		},
		addCoordinates(coordinates){
			let self = this
			let search_results = {
				"gps" : [],
			}

			// Arrondir les coordonnées à 6 décimales
			coordinates[0] = Math.round(coordinates[0] * 1000000) / 1000000
			coordinates[1] = Math.round(coordinates[1] * 1000000) / 1000000

			search_results.gps.push({
				"properties" : {
					"name" : coordinates[1] + ', ' + coordinates[0],
				},
				"geometry" : {
					"coordinates" : coordinates
				}
			})
			
			//RZ--> On ajoute les résultats à la liste
			self.addResults(_.cloneDeep(search_results))			
		},
		/**
		 * Convertit les degrés-minutes-secondes en décimal
		 */
		dmsToDecimal(degrees, minutes, seconds, direction) {
			let decimal = degrees + (minutes / 60) + (seconds / 3600)
			
			if (direction === 'S' || direction === 'W') {
				decimal = -decimal
			}
			
			return decimal
		},
		/**
		 * Convertit les coordonnées Lambert 93 en WGS84 avec proj4
		 */
		convertLambert93ToWGS84(x, y) {
			proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 " +
					"+lon_0=3 +x_0=700000 +y_0=6600000 " +
					"+ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

			// Conversion Lambert93 → WGS84
			const wgs84Coord = proj4("EPSG:2154", "WGS84", [x, y]);

			return [wgs84Coord[0], wgs84Coord[1]];
		},
		/**
		 * Vérifie si des coordonnées sont dans les limites WGS84
		 */
		isValidWGS84(lat, lng) {
			return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
		},
		convertPlusCodeToWGS84(plusCode){
			let self = this
			self.updateState('gps', 'loading')
			if (this.gps_cancelSearch) this.gps_cancelSearch.cancel('Start new search, stop active search');
			this.gps_cancelSearch = axios.CancelToken.source();

			delete plusCode[0]
			let plus_code = plusCode.join(',')
			let base64_plus_code = window.btoa(encodeURI(plus_code))

			axios.get('/plugin_projet/plugin_projet_iannuaire/get_coordinates_from_plus_code/'+base64_plus_code, { cancelToken: this.gps_cancelSearch.token })
		      .then(function (response) {				  
				//RZ--> Si on a des résultats et qu'il n'y a pas d'erreur
				if(response.data?.error == undefined && response.data.results.length > 0){					
					let coordinates = [response.data.results[0].geometry.location.lng, response.data.results[0].geometry.location.lat]
					self.addCoordinates(coordinates)
				}

				self.updateState('gps', 'loaded')
			})
		}
	},
	computed:{
		google: gmapApi,
	},
	components:{
		
	}
}